import { gql } from '@apollo/client'

export const CONTRACTS_QUERY = gql`
  query Contracts($providerCode: String!, $templateID: String!) {
    contracts(providerCode: $providerCode, templateID: $templateID) {
      ID
      Accommodations {
        Name
        NameFA
        PropertyCode
        DisplayPropertyCode
        ID
      }
      Active
      Channels {
        ChannelCode
        DisplayChannelCode
        CustomerCode
      }
      From
      RatePlans {
        PropertyCode
        DisplayPropertyCode
        RoomTypeCode
        DisplayRoomTypeCode
        RatePlanCode
        DisplayRatePlanCode
      }
      Title
      To
    }
  }
`
export const CONTRACT_QUERY = gql`
  query Contract(
    $providerCode: String!
    $templateID: String!
    $contractID: String!
  ) {
    contract(
      providerCode: $providerCode
      templateID: $templateID
      contractID: $contractID
    ) {
      ID
      Accommodations {
        Name
        NameFA
        PropertyCode
        DisplayPropertyCode
        ID
      }
      Active
      Channels {
        ChannelCode
        DisplayChannelCode
        CustomerCode
      }
      From
      RatePlans {
        PropertyCode
        DisplayPropertyCode
        RoomTypeCode
        DisplayRoomTypeCode
        RatePlanCode
        DisplayRatePlanCode
      }
      Title
      To
    }
  }
`
export const MODIFY_CONTRACT_MUTATION = gql`
  mutation ModifyContract(
    $input: ContractInput!
    $providerCode: String!
    $templateID: String!
    $contractID: String!
  ) {
    modifyContract(
      input: $input
      providerCode: $providerCode
      templateID: $templateID
      contractID: $contractID
    ) {
      message
    }
  }
`
export const GENERATE_CONTRACT_MUTATION = gql`
  mutation GenerateContract(
    $input: ContractInput!
    $providerCode: String!
    $templateID: String!
  ) {
    generateContract(
      input: $input
      providerCode: $providerCode
      templateID: $templateID
    ) {
      message
    }
  }
`
